import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
    const accessToken = localStorage.getItem("accessToken"); // Get token from localStorage

    if (!accessToken) {
        return <Navigate to="/login" replace />; // Redirect to login if no token
    }

    return children; // Render the protected page
};

export default ProtectedRoute;
